import script from "./ErrorLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorLogs.vue?vue&type=script&setup=true&lang=js"

import "./ErrorLogs.vue?vue&type=style&index=0&id=3df58f27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3df58f27"]])

export default __exports__